/*
 *  I11PERCHADISCHAI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 22:01:02 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I11PERCHADISCHA_SECTION_0_TITLE:
    'Calculez les pertes de charges linéaires de votre installation en fonction du diamètre de tuyauterie et du débit',
  I11PERCHADISCHA_tube_uuid: 'Diamètre intérieur ',
  I11PERCHADISCHA_in_debit: 'Debit',
  I11PERCHADISCHA_res_vitesse: 'Vitesse',
  I11PERCHADISCHA_viscosite_uuid: '',
  I11PERCHADISCHA_SECTION_1_TITLE: 'Type de régime',
  I11PERCHADISCHA_perteCharg_uuid: 'Unité calcul pertes de charges: ',
  I11PERCHADISCHA_res_pdcParMetre: 'Pertes de charges par m',
  I11PERCHADISCHA_in_longueur: 'Longeur',
  I11PERCHADISCHA_res_pdcTotale: 'Pertes de charges totale',
  I11PERCHADISCHA_in_rugosite: 'Rugosité',
  I11PERCHADISCHA_SECTION_2_TITLE: 'Résultats'
}
